import script from "./RedditView.vue?vue&type=script&setup=true&lang=js"
export * from "./RedditView.vue?vue&type=script&setup=true&lang=js"

import "./RedditView.vue?vue&type=style&index=0&id=5288126c&lang=scss"

const __exports__ = script;

export default __exports__